<div class="h-full w-full flex flex-col overflow-y-auto scrollbar-transparent space-y-4">

    <div class="shrink-0">
        <h2 class="text-base/7 font-semibold text-primary">Agentic Creator Persona</h2>
        <p class="text-sm/6 text-secondary">We're going to analyse your settings and create a creator persona for you.
        </p>
    </div>

    @if (reviewContentMode()) {
    <div
        class="flex-1 overflow-y-auto scrollbar-transparent border border-gray-200 dark:border-white/10 rounded-xl p-4">

        <div class="w-full">

            <div class="w-full flex flex-wrap items-center justify-between sm:flex-nowrap">
                <div class="flex-1">
                    <h3 class="text-base font-semibold text-primary">Ideal Creator Profile - Suggestion</h3>
                    <p class="mt-1 text-sm text-secondary">Based on your brief, here is a suggestion
                        for an ideal creator profile. Make changes as you see fit.</p>
                </div>
            </div>

            <div class="mt-4 space-y-4 w-full">
                @if (createBriefService.creatorProfileModel() &&
                createBriefService.creatorProfileModel()!.creator_audience) {
                <article class="flex w-full flex-col items-start justify-between">
                    <div class="group relative w-full">
                        <h3 class="mt-3 text-sm font-semibold text-primary group-hover:text-gray-300">
                            Creator Audience
                        </h3>
                        <div class="mt-1">
                            <textarea id="comment" rows="2" class="input-textarea text-primary"
                                [value]="createBriefService.creatorProfileModel()?.creator_audience || ''"
                                (input)="updateCreatorAudience($event)"></textarea>
                        </div>
                    </div>
                </article>
                }

                @if (createBriefService.creatorProfileModel() &&
                createBriefService.creatorProfileModel()!.creator_content_style) {
                <article class="flex w-full flex-col items-start justify-between">
                    <div class="group relative w-full">
                        <h3 class="mt-3 text-sm font-semibold text-primary group-hover:text-gray-300">
                            Creator Content Style
                        </h3>
                        <div class="mt-1">
                            <textarea id="comment" rows="2" class="input-textarea text-primary"
                                [value]="createBriefService.creatorProfileModel()?.creator_content_style || ''"
                                (input)="updateCreatorContentStyle($event)"></textarea>
                        </div>
                    </div>
                </article>
                }

                @if (createBriefService.creatorProfileModel() &&
                createBriefService.creatorProfileModel()!.creator_engagement_metrics) {
                <article class="flex w-full flex-col items-start justify-between">
                    <div class="group relative w-full">
                        <h3 class="mt-3 text-sm font-semibold text-primary group-hover:text-gray-300">
                            Creator Engagement Metrics
                        </h3>
                        <div class="mt-1">
                            <textarea id="comment" rows="2" class="input-textarea text-primary"
                                [value]="createBriefService.creatorProfileModel()?.creator_engagement_metrics || ''"
                                (input)="updateCreatorEngagementMetrics($event)"></textarea>
                        </div>
                    </div>
                </article>
                }

                @if (createBriefService.creatorProfileModel() &&
                createBriefService.creatorProfileModel()!.creator_persona) {
                <article class="flex w-full flex-col items-start justify-between">
                    <div class="group relative w-full">
                        <h3 class="mt-3 text-sm font-semibold text-primary group-hover:text-gray-300">
                            Creator Persona
                        </h3>
                        <div class="mt-1">
                            <textarea id="comment" rows="2" class="input-textarea text-primary"
                                [value]="createBriefService.creatorProfileModel()?.creator_persona || ''"
                                (input)="updateCreatorPersona($event)"></textarea>
                        </div>
                    </div>
                </article>
                }

                @if (createBriefService.creatorProfileModel() &&
                createBriefService.creatorProfileModel()!.creator_specific_characteristics) {
                <article class="flex w-full flex-col items-start justify-between">
                    <div class="group relative w-full">
                        <h3 class="mt-3 text-sm font-semibold text-primary group-hover:text-gray-300">
                            Creator Specific Characteristics
                        </h3>
                        <div class="mt-1">
                            <textarea id="comment" rows="2" class="input-textarea text-primary"
                                [value]="createBriefService.creatorProfileModel()?.creator_specific_characteristics || ''"
                                (input)="updateCreatorSpecificCharacteristics($event)"></textarea>
                        </div>
                    </div>
                </article>
                }

            </div>
        </div>

    </div>
    } @else {
    <div
        class="flex-1 overflow-y-auto scrollbar-transparent border border-gray-200 dark:border-white/10 rounded-xl p-4">

        @if (loadingAiRecommendation()) {
        <div class="flex flex-col space-y-4">
            @for (message of chatMessages(); track $index) {
            @if (message.displayedText || $index <= currentMessageIndex()) { <!-- AI Message -->
                <div class="flex items-start gap-x-3">
                    <!-- AI Avatar -->
                    <div class="shrink-0 size-8 rounded-full bg-primary flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-white">
                            <path d="M12 8V4H8" />
                            <rect width="16" height="12" x="4" y="8" rx="2" />
                            <path d="M2 14h2" />
                            <path d="M20 14h2" />
                            <path d="M15 13v2" />
                            <path d="M9 13v2" />
                        </svg>
                    </div>
                    <!-- Message Bubble -->
                    <div class="flex-1 bg-gray-100 dark:bg-gray-800 rounded-lg rounded-tl-none p-4">
                        <p class="text-sm text-primary whitespace-pre-wrap">
                            <span>{{ message.displayedText }}</span>
                            @if ($index === currentMessageIndex() && !message.isComplete) {
                            <span
                                class="inline-block w-2 h-4 bg-primary dark:bg-primary/75 animate-pulse ml-1">|</span>
                            }
                        </p>
                    </div>
                </div>
                <!-- AI Message - END -->
                }
                }
        </div>
        }

    </div>
    }
</div>